import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveThumbnailUrl } from '../utils/hlsPlayer';
import { useAuth, usePlayer } from '../contexts/AppContext';
import { VideoCard } from '../components/VideoCard';
import { Heart, Sparkles } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const EYE_ICON_URL = "/sidebar-logo.png";

const MOCK_THUMBNAILS = [
  "https://images.unsplash.com/photo-1762279801044-3c37872f4534?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdsb3dpbmclMjBnZW9tZXRyaWMlMjBmbHVpZHxlbnwwfHx8fDE3NzUxMzczNjZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/28583190/pexels-photo-28583190.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1764258906659-e966a089ed7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdsb3dpbmclMjBnZW9tZXRyaWMlMjBmbHVpZHxlbnwwfHx8fDE3NzUxMzczNjZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1722708773274-e791ab361dd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxjeWJlcnB1bmslMjBmdXR1cmlzdGljJTIwZGolMjBjb25jZXJ0fGVufDB8fHx8MTc3NTEzNzM2Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1741344694428-f84a93bc4eca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxjeWJlcnB1bmslMjBmdXR1cmlzdGljJTIwZGolMjBjb25jZXJ0fGVufDB8fHx8MTc3NTEzNzM2Nnww&ixlib=rb-4.1.0&q=85"
];

export const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const { axiosInstance } = useAuth();
  const { playVideo } = usePlayer();
  const navigate = useNavigate();


  const fetchFavorites = useCallback(async () => {
    try {
      const res = await axiosInstance.get('/favorites');
      setFavorites(res.data);
    } catch (err) {
      console.error('Failed to fetch favorites:', err);
    } finally {
      setLoading(false);
    }
  }, [axiosInstance]);

  useEffect(() => {
    fetchFavorites();
  }, [fetchFavorites]);

  const goToArtist = (video) => {
    const artistId = video.artist_id || video.user_id;
    if (artistId) {
      navigate(`/creator/${artistId}`);
    }
  };

  const getThumbnail = (video) => {
    return resolveThumbnailUrl(video);
  };

  return (
    <div className="pb-32 px-6">
      <div className="py-8">
        <div className="flex items-center gap-3 mb-8">
          <img src={EYE_ICON_URL} alt="AUDIVUE" className="w-12 h-12 rounded-xl shadow-lg" />
          <div>
            <h1 className="text-3xl font-bold text-white">
              Liked Videos
            </h1>
            <p className="text-zinc-400 text-sm">{favorites.length} videos</p>
          </div>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => (
              <div key={`skeleton-${i}`} className="aspect-video bg-zinc-900 rounded-xl animate-pulse" />
            ))}
          </div>
        ) : favorites.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="w-20 h-20 text-zinc-700 mx-auto mb-4" />
            <h3 className="text-xl text-zinc-400 mb-2">No liked videos yet</h3>
            <p className="text-zinc-500">Videos you like will appear here</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
            {favorites.map((video, index) => (
              <VideoCard
                key={video.id}
                video={video}
                thumbnail={getThumbnail(video, index)}
                onClick={() => playVideo(video, favorites, index)}
                onArtistClick={goToArtist}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
